import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-service-list',
  templateUrl: './service-list.component.html',
  styleUrls: ['./service-list.component.css']
})
export class ServiceListComponent implements OnInit {

  @Input() oldServicesSubscribed;

  constructor() { }

  ngOnInit() {
  }

}
